import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from './material.module';
import { LoaderComponent } from './loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

@NgModule({
	declarations: [
		LoaderComponent
	],
	imports: [
		MaterialModule,
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		ShareButtonsModule,
		ShareIconsModule
	],
	exports: [
		MaterialModule,
		LoaderComponent,
		ReactiveFormsModule,
		FormsModule,
		GoogleMapsModule,
		ShareButtonsModule,
		ShareIconsModule
	],
	providers: [
		DatePipe,
	]
})
export class SharedModule { }
